<script lang="ts">
  import { debounce } from 'es-toolkit/compat'
  import queryClient from '../../constants/query-client'
  import { useProjectQueries } from '../../hooks/project'
  import { onDestroy, onMount } from 'svelte'
  import { get } from 'svelte/store'
  import { storeScene } from '../../stores/scene'
  import { pendingPlacement } from '../../stores/placement'
  import { hasUnsavedChanges } from '../../stores/unsaved-changes'

  const { loading }: { loading: boolean } = $props()
  const { saveProjectMutation } = useProjectQueries()

  const onSceneUpdate = debounce(
    () => {
      const scene = get(storeScene)
      if (
        scene
        && !loading
        && !saveProjectMutation.isPending
        && scene.children.length > 0
        && !window.location.pathname.includes('/preview')
        && get(pendingPlacement) === null
      ) {
        saveProjectMutation.mutate()
      }
    },
    5000,
    { maxWait: 20000 },
  )

  let unsubscribeFromQueryCache: () => void

  $effect(() => {
    if (loading) onSceneUpdate.cancel()
  })

  const onBeforeUnload = (e: BeforeUnloadEvent) => {
    if (get(hasUnsavedChanges)) {
      e.preventDefault()
    }
  }

  onMount(() => {
    unsubscribeFromQueryCache = queryClient
      .getQueryCache()
      .subscribe((notification) => {
        if (
          notification.type === 'updated'
          && (notification.action.type === 'success'
            || notification.action.type === 'invalidate')
          && notification.query.queryKey[0] === 'canvas'
        ) {
          if (!loading) {
            hasUnsavedChanges.set(true)
            onSceneUpdate()
          }
        }
      })

    window.addEventListener('beforeunload', onBeforeUnload)
  })

  onDestroy(() => {
    unsubscribeFromQueryCache()
    onSceneUpdate.cancel()
    saveProjectMutation.reset()
    window.removeEventListener('beforeunload', onBeforeUnload)
    hasUnsavedChanges.set(false)
  })
</script>
